import * as React from 'react';

interface H3Props {
}

const H3: React.FC<H3Props> = (props) => {
  return <h3 className="mt-4 mb-2">{props.children}</h3>
};

export default H3;